const dataList = {
  status: 200,
  count: 2,
  data: {
    pushcart_product: [
      {
        image: 'https://toppng.com/uploads/preview/roger-berry-avatar-placeholder-11562991561rbrfzlng6h.png',
        name: 'Name 1',
        price: 5000,
        discountType: 'discount type',
        discount: 'discount',
        status: true
      }
    ]
  }
}
export { dataList }